import React from 'react';

const QuestionCount = ({ counter, total }) => (
  <div className="new-exam__body__avt">
    {/* Question <span>{counter}</span> of <span>{total}</span> */}
    Question <span>{counter}/{total}</span>
  </div>
);

export default QuestionCount;



// WEBPACK FOOTER //
// ./src/components/NewExam/QuestionCount.js